export function Verified() {
  return (
    <path
      fill="currentColor"
      d="M24 0c6.41 0 12.438 2.496 16.97 7.03C45.504 11.561 48 17.59 48 24c0 6.41-2.496 12.438-7.03 16.97C36.438 45.504 30.41 48 24 48c-6.41 0-12.438-2.496-16.97-7.03C2.495 36.438 0 30.41 0 24c0-6.41 2.496-12.438 7.03-16.97C11.561 2.495 17.59 0 24 0zm0 2.095C11.922 2.095 2.095 11.922 2.095 24c0 12.078 9.827 21.905 21.905 21.905 12.078 0 21.905-9.827 21.905-21.905 0-12.078-9.827-21.905-21.905-21.905zm9.628 14.082c.558-.558 1.462-.558 2.02 0s.558 1.463 0 2.02L22.023 31.823c-.28.279-.645.418-1.01.418-.366 0-.732-.14-1.01-.418l-7.651-7.651c-.558-.558-.558-1.463 0-2.02.558-.558 1.462-.558 2.02 0l6.64 6.64z"
    />
  )
}
